<template>
	<div style="width: 100%; height: 100%;">
		<!-- 地图区域 -->
		<div class="map_div">
			<!-- <h1>房屋搜索</h1> -->
			<baidu-map
			style="width: 100%; height: 100%;"
			:center="center"
			:zoom="zoom"
			:min-zoom="10"
			:max-zoom="18"
			:map-style="mapStyle"
			scroll-wheel-zoom="true">
				<bm-marker
				:position="houseMarkPoint"
				:dragging="true"
				animation="BMAP_ANIMATION_BOUNCE">
					  <bm-label :content= "xiaoqu" :labelStyle="{color: 'red', fontSize : '20px'}" :offset="{width: -35, height: 30}"/>
				</bm-marker>
			</baidu-map>
		</div>

		<!-- 搜索区域 -->
		<div class="search_div">
			<div style="display: flex;">
				<el-input v-model="form.keyword" placeholder="输入网点名称搜索" style="margin-right: 20px;"></el-input>
				<el-button type="primary" @click="search" style="background-color: #2c3e50">搜索</el-button>
			</div>
		</div>

		<!-- 搜索结果列表 -->
		<el-drawer
		  style="padding: 20px; box-sizing: border-box;"
		  title="搜索结果"
		  :visible.sync="drawer"
		  :direction="direction"
		  :before-close="handleClose">

		  <div style="width: 100%; height: 100%; padding: 20px; box-sizing: border-box; overflow: scroll;">

			  <!-- 房屋信息 -->
			  <div class="house_div" v-for="house in houses" @click="showHouseMarkPoint(house.lng,house.lat,house.xiaoqu)">
			  	<div class="left_div">
<!--			  		<img :src="'http://localhost:8888/house/file/download?fileName='+house.image" style="background-color: aquamarine; width: 180px; height: 100%;"/>-->
			  	</div>
			  	<div class="right_div">
			  		<div style="font-size: 20px; font-weight: 900;">房屋标题：{{house.subject}}</div>
			  		<div style="font-size: 12px; color: gray;">房屋描述：{{house.info}}</div>
			  		<div>{{house.jishi}}室{{house.jiting}}厅</div>
			  		<div>小区名称：{{house.xiaoqu}}</div>
			  		<div style="align-self: flex-end; font-weight: 900; color: red;">价格：￥{{house.price}}万元</div>
			  	</div>
			  </div>
		  </div>

		</el-drawer>
	</div>

</template>

<script>
	export default{
		data(){
			return{
				drawer: false,
				center: "济南市",
				zoom: 14,
				form: {
					keyword: "",
					jishi: "",
					jiting: "",
					minPrice: "",
					maxPrice: ""
				},
				mapStyle:{
					features: ["road", "building","water","land"],//隐藏地图上的poi
					style : "midnight"  //设置地图风格为高端黑
				},
				houses: [],
				//房屋地图位置标记点
				houseMarkPoint: {},
				xiaoqu: ""
			}
		},
		methods: {
			//搜索房屋信息
			searchApi(){
				//发送axios请求获取后端的数据
				this.axios({
					method: "POST",
					url: "http://localhost:8888/house/house/search",
					data: this.form
				}).then((result)=>{
					console.log("房屋搜索结果",result.data);
					//将从后端拿到的房屋搜索信息存到houses中
					this.houses = result.data;
					//弹出右边的信息框
					this.drawer = true;
				});

			},
	showHouseMarkPoint(lng,lat,xiaoqu){
				var point = {
					lng: lng,
					lat: lat
				};
				this.xiaoqu = xiaoqu;
				//改变房屋的地图位置
				this.houseMarkPoint = point;
				//改变地图的中心点
				this.center = point;
				//改变地图的缩放比例,最大缩放比例是19
				this.zoom = 19;
			}
		}
	}
</script>

<style>
	.BMap_cpyCtrl {
		display: none!important;
	}
	.anchorBL {
		display: none!important;
	}

	.map_div{
		width: 100%;
		height: 100%;
		/* background-color: aliceblue; */
	}

	.search_div{
		width: 400px;
		height: auto;
		background-color: rgba(22, 31, 38, 0.87);
		position: fixed;	/* 固定定位 */
		top: 100px;
		left: 40%;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		opacity: 1;
		padding: 10px;
		box-sizing: border-box;
	}
	.search_div input{
		background-color: rgba(22, 31, 38, 0.87);
	}
	.house_div{
		width: 100%;
		height: 200px;
		/* background-color: aquamarine; */
		margin-bottom: 10px;
		border-radius: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		display: flex;
		overflow: hidden;	/* 超出的部分全部隐藏 */
	}

	.left_div{
		height: 100%;
	}

	.right_div{
		height: 100%;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: flex-start;
		padding: 10px 20px;
		box-sizing: border-box;
	}
</style>
